export default __webpack_public_path__ + "static/media/resultSample.ccaa78c4.png";